import { FIELD_TYPES } from "constants/template-field-type";
export default {
    src: {
        type: FIELD_TYPES.TEXT,
        label: "Iframe URL"
    }
};
